/**
 * Exact-match allowed origins for Funnel Fuel (and related) UIs that may open this portal.
 * Add every deployment URL; also set REACT_APP_ALLOWED_PARENT_ORIGINS (comma-separated) in env.
 */
const fromEnv = (process.env.REACT_APP_ALLOWED_PARENT_ORIGINS || '')
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean);

/** @type {string[]} */
export const allowedParentOriginsList = [
  'http://localhost:3000',
  'https://localhost:3000',
  ...fromEnv,
];

export const allowedParentOrigins = new Set(allowedParentOriginsList);

/**
 * @param {string | null | undefined} origin
 * @returns {boolean}
 */
export function isAllowedParentOrigin(origin) {
  if (!origin) return false;
  return allowedParentOrigins.has(origin);
}
